import clsx from "clsx";
import type { ButtonProps as RACButtonProps } from "react-aria-components";
import { Button as RACButton } from "react-aria-components";
import styles from "./UnstyledRACButton.module.css";

export const UnstyledRACButton = ({
  children,
  className,
  ...props
}: RACButtonProps) => (
  <RACButton {...props} className={clsx(styles.unstyledButton, className)}>
    {children}
  </RACButton>
);
